import { HNISO4217Alpha3SupportedCurrency } from 'API';

export type MoneyInput = { value: number; currencyCode: HNISO4217Alpha3SupportedCurrency };

export const toMoney = (cents: number): MoneyInput => ({
  value: cents,
  currencyCode: HNISO4217Alpha3SupportedCurrency.USD,
});

/**
 * SEE-1401: convert a form amount (dollars, possibly the *string* the number input
 * stores) into a cents payload. Anything that is not a positive finite number
 * (empty, "0", 0, null, NaN) is treated as "no limit" and returns null. A $0 limit
 * must never be sent because it tells the card network to decline everything.
 */
export const dollarsToLimit = (dollars: unknown): MoneyInput | null => {
  if (dollars === null || dollars === undefined || dollars === '') return null;
  const n = Number(dollars);
  if (!Number.isFinite(n)) return null;
  // Guard on the rounded cents, not the dollar input: "0.001" is > 0 but rounds to 0 cents.
  const cents = Math.round(n * 100);
  return cents > 0 ? toMoney(cents) : null;
};

/** Existing stored limit (already in cents) to resend unchanged, or null if none/invalid. */
export const existingLimit = (stored: { value?: number | null } | null | undefined): MoneyInput | null =>
  stored?.value != null && stored.value > 0 ? toMoney(stored.value) : null;
